import { render, staticRenderFns } from "./psd.vue?vue&type=template&id=e7f8e1f8"
import script from "./psd.vue?vue&type=script&lang=js"
export * from "./psd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports